import {
  RhCard,
  RhIcon,
  RhInputFormik,
  RhTimelineItem,
  Yup,
} from "@rhythm-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Formik } from "formik";
import React from "react";

import api from "@/services/api";

import { Button } from "@/components/ui/Button";

const AddNote = ({
  jobId,
  setIsCreateNote,
}: {
  jobId: number | null;
  setIsCreateNote: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const queryClient = useQueryClient();
  const postCandidateNote = useMutation({
    mutationFn: (formData: { note: string }) =>
      jobId === null
        ? Promise.reject(new Error("insufficient data"))
        : api.company.postJobRequirementNotes(jobId.toString(), {
            note: formData.note,
          }),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ["JOBS", "ITEM", { jobId }],
      });
      setIsCreateNote(false);
    },
  });

  const validationSchema = Yup.object().shape({
    note: Yup.string().required("Required"),
  });
  //

  return (
    <RhTimelineItem
      className="w-full"
      timelineItemCircleClass="border-none !bg-brandGreen-50 h-[28px] w-[28px] top-[1px] left-[-13px]"
      circleComponent={
        <RhIcon
          icon={"tabler:notes"}
          className="h-[16px] w-[16px] text-success-600"
        />
      }
    >
      <RhCard className="px-tsm py-tnano">
        <Formik
          initialValues={{ note: "" }}
          onSubmit={postCandidateNote.mutate}
          validationSchema={validationSchema}
        >
          <Form>
            <h4>Notes</h4>
            <RhInputFormik
              type="textarea"
              name="note"
              className="my-tsm w-full"
              rows={3}
              placeholder="Add notes here"
              autoFocus
            />

            <div className="flex justify-end gap-tnano">
              <Button
                type="button"
                variant="tertiary"
                onClick={() => setIsCreateNote(false)}
              >
                Cancel
              </Button>
              <Button isLoading={postCandidateNote.isLoading} type="submit">
                Add
              </Button>
            </div>
          </Form>
        </Formik>
      </RhCard>
    </RhTimelineItem>
  );
};

export default AddNote;
